import Cookie from "js-cookie";

const api = Cookie.withAttributes({
  path: "/",
  expires: 60,
  domain: process.env.REACT_APP_PARENT_URL
});

export default api;
